import axios from 'axios'
import { ChartType } from '@domain' // eslint-disable-line

export const state = {
  schoolYears: new Promise((resolve, reject) => {}), // the init promise, it never resolves
}

export const mutations = {
  SetSchoolYears(state, schoolYears) {
    state.schoolYears = schoolYears
  },
}

const CacheKey = '_wizard_school_years'

let getLocalSchoolYears = function(chartType) {
  let cacheObj = sessionStorage.getItem(CacheKey)
  if (cacheObj === null) {
    return null
  }
  cacheObj = JSON.parse(cacheObj)
  let res = ChartType.case(
    {
      CollegeReadiness: () => cacheObj['CollegeReadiness'],
      AdvDualCoursesTaken: () => cacheObj['AdvDualCoursesTaken'],
      SAToACTParticipation: () => cacheObj['SAToACTParticipation'],
      DAPRecommendedPlan: () => cacheObj['DAPRecommendedPlan'],
      AttendanceRates: () => cacheObj['AttendanceRates'],
      STAAROutcomes: () => cacheObj['STAAROutcomes'],
      TSIA: () => cacheObj['TSIA'],
    },
    chartType
  )
  return res ? JSON.parse(res) : res
}

let setLocalSchoolYears = function(chartType, schoolYears) {
  let cacheObj = sessionStorage.getItem(CacheKey)
  schoolYears = JSON.stringify(schoolYears)
  let newCacheObj = {}
  if (cacheObj !== null) {
    newCacheObj = JSON.parse(cacheObj)
  }
  ChartType.case(
    {
      CollegeReadiness: () => {
        newCacheObj['CollegeReadiness'] = schoolYears
        return newCacheObj
      },
      AdvDualCoursesTaken: () => {
        newCacheObj['AdvDualCoursesTaken'] = schoolYears
        return newCacheObj
      },
      SAToACTParticipation: () => {
        newCacheObj['SAToACTParticipation'] = schoolYears
        return newCacheObj
      },
      DAPRecommendedPlan: () => {
        newCacheObj['DAPRecommendedPlan'] = schoolYears
      },
      AttendanceRates: () => {
        newCacheObj['AttendanceRates'] = schoolYears
      },
      STAAROutcomes: () => {
        newCacheObj['STAAROutcomes'] = schoolYears
      },
      TSIA: () => {
        newCacheObj['TSIA'] = schoolYears
      },
    },
    chartType
  )
  sessionStorage.setItem(CacheKey, JSON.stringify(newCacheObj))
}

export const actions = {
  /**
   * @param {ChartType} chartType
   */
  SearchSchoolYears(
    {
      // @ts-ignore
      commit,
    },
    chartType
  ) {
    let result = getLocalSchoolYears(chartType)
    if (result) {
      let p = Promise.resolve(result)
      commit('SetSchoolYears', p)
      return p
    }
    let url = ChartType.case(
      {
        CollegeReadiness: () => '/api/v3/availableschoolyear',
        AdvDualCoursesTaken: () => '/api/v4/availableschoolyear',
        SAToACTParticipation: () => '/api/v5/availableschoolyear',
        DAPRecommendedPlan: () => '/api/v6/availableschoolyear',
        AttendanceRates: () => '/api/v7/availableschoolyear',
        STAAROutcomes: () => '/api/v8/availableschoolyear',
        TSIA: () => '/api/v9/availableschoolyear',
      },
      chartType
    )

    result = axios.get(url).then(resp => resp.data)
    commit('SetSchoolYears', result)
    result.then(val => {
      setLocalSchoolYears(chartType, val)
    })
    return result
  },
}
